// import $ from 'jquery';
// import Rellax from 'rellax';

/**
 * initializeBlock
 *
 * Adds custom JavaScript to the block HTML.
 *
 * @date    15/4/19
 * @since   1.0.0
 *
 * @param   object $block The block jQuery element.
 * @param   object attributes The block attributes (only available when editing).
 * @return  void
 */

// Initialize dynamic block preview (editor).
// if( window.acf ) {
//     window.acf.addAction( 'render_block_preview/type=hero-feature', initializeBlock );
// }
// var rellax = new Rellax('.rellax', {
//     speed: 1.75,
//     center: false,
//     wrapper: null,
//     round: true,
//     vertical: true,
//     horizontal: false
// });
// $(window).on('scroll', function () {
//     var pixs = $(document).scrollTop(),
//         pixs = pixs / 40;
//     $(".hero-feature--container--image").css({"-webkit-filter": "blur("+pixs+"px)","filter": "blur("+pixs+"px)" });
// });